module.exports = __webpack_public_path__ + "img/careers-job-detail-header.jpg?d2bf7a0a622caecbd84d68470f31f513";